module.exports = __webpack_public_path__ + "static/media/women-smile.d0023099.png";